import { connect } from 'react-redux';
import { isSourceImageVertical } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Image/_helpers';
import { AppState } from '../../../../../types/store';
import {
  updateCoverDeviation,
  updateCoverDeviationOffsetY,
  deleteCoverDeviation,
} from '../../../../actions/deviations';
import {
  FirstTimeFlag,
  dropFirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { getCoverDeviation } from '../../../../selectors/deviations';

import { Props } from './ProfileHeroEdit';

const mapStateToProps = (state: AppState, ownProps: Props) => {
  const coverDeviation = getCoverDeviation(state);
  const showWatchIntro =
    !ownProps.showProfileHeroAid && ownProps.showProfileEditAid;

  return {
    coverDeviation,
    withPositionManager: isSourceImageVertical(coverDeviation),
    showWatchIntro,
  };
};

const mapDispatchToProps = {
  updateCoverDeviation,
  deleteCoverDeviation,
  updateCoverDeviationOffsetY,
  dropProfileEditAidFlag: () =>
    dropFirstTimeFlag({ flag: FirstTimeFlag.ProfileEditAidNotClosed }),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
